import { getDateRangeByType } from '../../../../helpers/dateTime';
import { languageSelector } from '../../helpers/utility';

/**
 * Default date selection of the flexiShuttle US dashboard. Shared by the screen and by
 * the route guard that completes its URL, so the two cannot drift apart.
 */
export const DASHBOARD_US_DEFAULT_DATE = 'thisMonth';

/**
 * Canonical query of the flexiShuttle US dashboard — the params its cards read back out
 * of `$route.query` to build drill-down links.
 *
 * Presets (thisMonth, lastMonth, ...) are always recomputed from today, matching what the
 * screen itself derives from the selection; a customDate range is carried through as-is.
 *
 * @param {Object} [query] - Current route query
 * @returns {{ lang: string, date: string, fromDate: string, toDate: string }}
 */
export function canonicalDashboardUsQuery(query = {}) {
  const { type, fromDate, toDate } = getDateRangeByType(query.date || DASHBOARD_US_DEFAULT_DATE, {
    fromDate: query.fromDate,
    toDate: query.toDate,
  });

  return { lang: query.lang || languageSelector(), date: type, fromDate, toDate };
}

/**
 * Whether the query already carries every canonical param, so the guard can let the
 * navigation through instead of redirecting (which would loop).
 *
 * @param {Object} query - Current route query
 * @returns {boolean}
 */
export function isDashboardUsQueryCanonical(query = {}) {
  const canonical = canonicalDashboardUsQuery(query);
  return Object.keys(canonical).every((key) => query[key] === canonical[key]);
}
